/*
 * @Author: your name
 * @Date: 2021-12-02 16:55:43
 * @LastEditTime: 2021-12-02 16:55:45
 * @LastEditors: Please set LastEditors
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \vue3-element-admin\src\store\modules\app\type.js
 */
export const TOGGLE_SLIDER = "TOGGLE_SLIDER";
export const SET_TOKEN = "SET_TOKEN";
export const SET_KEY = "SET_KEY";
export const SET_UNAME = "SET_UNAME";
export const SET_USER_INFO = "SET_USER_INFO";
export const SET_MENU_LIST = "SET_MENU_LIST";
export const SET_PRODUCT = "SET_PRODUCT";
export const SET_USER_LOCATION = "SET_USER_LOCATION";
export const SET_MINI_USER_ID = "SET_MINI_USER_ID";
export const SET_ACTION_NUM = "SET_ACTION_NUM";
export const SET_TIPS_SHOW = "SET_TIPS_SHOW";
export const SET_GARDEN_EXAMPLE = "SET_GARDEN_EXAMPLE";
export const SET_USER_ROLES = "SET_USER_ROLES";
export const SET_USER_CUR_ROLE = "SET_USER_CUR_ROLE";
